import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/downloadfile',
    name: 'HelloWorld',
    component: HelloWorld
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js